<template>
    <div :key="componentKey">
        <div id="injectableJS"></div>

        <base-modal
            v-model="modal.open"
            :title="$t('module-budget.repair-graphic.modal-open.title')"
            modal-width="680px"
            :persistent="true"
        >
            <template v-slot:modal-body>
                <div
                    v-for="item in modal.contents"
                    :key="
                        item.Id +
                        '' +
                        item.itemParts.KorId +
                        '' +
                        item.itemParts.WorkId
                    "
                >
                    <div class="items-texts">
                        <base-checkbox
                            :config="mixinCheckboxValue('maintenance', item)"
                        ></base-checkbox>
                    </div>
                </div>
            </template>

            <template v-slot:modal-actions>
                <div class="mr-2">
                    <v-btn class="primary-button" text @click="goBack">
                        {{ $t("back") }}
                    </v-btn>
                </div>
                <div class="ml-2">
                    <v-btn
                        class="primary-button"
                        text
                        @click="modal.open = false"
                    >
                        {{ $t("close") }}
                    </v-btn>
                </div>
            </template>
        </base-modal>
    </div>
</template>

<script>
import { QuotationGraphicServicesGetByStep } from "@services/b2b/quotation/QuotationGraphicServices.js";
import BaseModal from "@components/shared/widgets/BaseModal.vue";

export default {
    components: {
        BaseModal,
        "area-items": () =>
            import("@components/b2b/budget-repair-graphic/ListAreaItems"),
        "base-checkbox": () =>
            import("@components/b2b/widgets/CheckBoxComponent.vue"),
    },
    data() {
        return {
            componentKey: 0,
            breadcrumb: [
                {
                    title: this.$t("module-budget.repair-graphic.breadcrumb1"),
                    routerLinkName: "budget",
                },
                {
                    title: this.$t("module-budget.repair-graphic.breadcrumb2"),
                },
            ],
            carImage: "",
            allCarItems: [],
            selectedItemsQueue: [],
            listItems: [],
            hoverItem: null,
            unfilteredListItems: [],
            currentItemNameProperty: "mainGroupName",
            searchListValue: "",
            modal: {
                open: false,
                operation: {
                    workId: -1,
                    workPosDescription: "",
                    workPosCriteriaDescription: "",
                    singleWorkTime: -1,
                },
                contents: [],
            },
        };
    },
    methods: {
        goBack() {
            this.modal.open = false;
            window.history.back();
        },
        getGraphicByStep(stepId, id) {
            this.$store.commit("loadings/setStateLoadingTemplate", true);
            QuotationGraphicServicesGetByStep(stepId, id)
                .then((response) => {
                    if (stepId != 4) {
                        var js = response.data.result.substring(
                            1,
                            response.data.result.length - 1
                        );

                        js = js.replace(
                            /onclick=\"clickOnElement\(([^)]+)\)/g,
                            'onclick="clickOnRepairGraphic($1)'
                        );
                        js = js.replace(
                            /onmouseover=\"showToolTip\(([^)]+)\)/g,
                            'onmouseover="showToolTipTest($1)'
                        );
                        js = js.replace(
                            /onmouseover=\"hideToolTip\(([^)]+)\)/g,
                            'onmouseover="hideToolTipTest($1)'
                        );

                        $("#injectableJS").html(js);
                    } else {
                        let result = JSON.parse(response.data.result);

                        if (!result || !result[0].ItemParts) {
                            throw new Error(
                                "Missing result or result[0].itemParts"
                            );
                        }

                        this.modal.contents = [];
                        let checkBoxClicked = false;

                        result.map((item) => {
                            item.ItemParts.map((el) => {
                                this.modal.contents.push({
                                    id: el.ItemMpId,
                                    checked: false,
                                    value: `${el.WorkTime}h ${" "} ${
                                        el.ItemMpText
                                    } ${" "} (${el.KorText}) ${" "} [${
                                        el.QualColText
                                    }]`,
                                    subtitle: el.KorText,
                                    itemParts: el,
                                    qualColId: el.QualColId ? el.QualColId : "",
                                });
                            });
                        });
                        this.modal.open = true;

                        if (checkBoxClicked) {
                            const isClutchKitContent = this.modal.contents.find(
                                (item) => item.id == 127
                            );
                            if (isClutchKitContent) {
                                this.getClutchKit(this.modal.contents);
                            }
                        }
                    }
                })
                .catch((error) => {
                    console.error(error);
                })
                .finally(() => {
                    this.$store.commit(
                        "loadings/setStateLoadingTemplate",
                        false
                    );
                });
        },
        mixinCheckboxValue(type, item) {
            let checked = false;

            let shoppingCart =
                this.$store.getters["budget/getB2bCurrentShoppingCart"];

            for (let i in shoppingCart.operations[type]) {
                if (
                    shoppingCart.operations[type][i].workId ==
                    item.itemParts.WorkId
                ) {
                    checked = true;
                }
            }

            return {
                id: item.itemParts.ItemMpId,
                checked: checked,
                value: `${item.itemParts.WorkTime}h ${" "} ${
                    item.itemParts.ItemMpText
                } ${" "} (${item.itemParts.KorText}) ${" "} [${
                    item.itemParts.QualColText
                }]`,
                subtitle: item.itemParts.KorText,
                itemParts: item.itemParts,
            };
        },
        clickOnRepairGraphic(id) {
            const currentStepId = parseInt(this.$route.params.stepId);
            const nextStepId = currentStepId + 1;

            this.$router.push({
                name: "budget_test_graphic",
                params: {
                    stepId: nextStepId,
                },
                query: {
                    id: id,
                },
            });
        },
        decodeHtml(html) {
            var txt = document.createElement("textarea");
            txt.innerHTML = html;
            return txt.value;
        },
    },
    mounted() {
        this.getGraphicByStep(
            this.$route.params.stepId,
            this.$route.query.id ?? this.$route.query.Id
        );
        window.showToolTipTest = function (text, event) {
            const tooltip = document.getElementById("toolTip");
            tooltip.innerText = this.decodeHtml(text);
            tooltip.style.top = event.offsetY - 50 + "px";
            tooltip.style.display = "block";
            if (event.offsetX < 400) {
                tooltip.style.left = event.offsetX + "px";
            }
            tooltip.style.opacity = 1;
            tooltip.style.zIndex = 1000;
            this.$emit("tooltip-name", text);
        }.bind(this);

        window.hideToolTipTest = function () {
            const tooltip = document.getElementById("toolTip");
            tooltip.innerText = "";
            tooltip.style.opacity = 0;

            // lol
            tooltip.style.top = 3000;
            tooltip.style.left = 3000;
            // lol
        }.bind(this);
    },
    created() {
        window.clickOnRepairGraphic = this.clickOnRepairGraphic.bind(this);
        window.showToolTipTest = this.showToolTipTest.bind(this);
        window.hideToolTip = this.hideToolTip.bind(this);
    },
    beforeUnmount() {
        if (window.clickOnRepairGraphic) {
            delete window.clickOnRepairGraphic;
        }
        delete window.showToolTip;
        delete window.hideToolTip;
    },
    watch: {
        $route(to) {
            this.getGraphicByStep(
                this.$route.params.stepId,
                this.$route.query.id ?? this.$route.query.Id
            );
        },
    },
};
</script>
